import React from 'react';
import { Route } from 'react-router-dom';
import { Page } from '../interfaces/Page';
import { ProtectedContainerProps } from '../interfaces/PagesProps';
import getPage from './getPage';

const getPages = (
  pages: Page[],
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
  basePathPages: string,
) => {
  const routes = pages.map((p) => getPage(p, isAuthenticated, ProtectedContainer, basePathPages));

  return (
    <Route path={`${basePathPages}`}>
      {routes}
    </Route>
  );
};

export default getPages;
